import React from 'react';
import { Route, Routes } from 'react-router-dom';
// KD-3735: one-organization pages ask which organization in the group view.
import RequireActingOrganization from 'components/RequireActingOrganization';
import ExperiencesList from './index';
import ExperienceCreate from './Form/ExperienceCreate';
import ExperienceEdit from './Form/ExperienceEdit';

export default function ExperiencesRoutes() {
  return (
    <Routes>
      <Route path="/" element={<ExperiencesList />} />
      <Route
        path="create"
        element={
          <RequireActingOrganization>
            <ExperienceCreate />
          </RequireActingOrganization>
        }
      />
      <Route path="edit/:experienceId/*" element={<ExperienceEdit />} />
    </Routes>
  );
}
